import { render, staticRenderFns } from "./SetPermissionsForEmployees.vue?vue&type=template&id=000e5265"
import script from "./SetPermissionsForEmployees.vue?vue&type=script&lang=js"
export * from "./SetPermissionsForEmployees.vue?vue&type=script&lang=js"
import style0 from "./SetPermissionsForEmployees.vue?vue&type=style&index=0&id=000e5265&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports